import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { CaretLeft, ChatCircle } from '@phosphor-icons/react';

export default function ConversationsPage() {
  const { user, api } = useAuth();
  const navigate = useNavigate();
  const [convos, setConvos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get('/chat/conversations');
        setConvos(data.conversations || []);
      } catch {} finally { setLoading(false); }
    };
    load();
  }, [api]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8DDD2] to-[#D6C9B8] pb-24 max-w-[480px] mx-auto" data-testid="conversations-page">
      <header className="sticky top-0 z-50 bg-white/70 backdrop-blur-xl border-b border-black/5 px-4 py-3 flex items-center gap-3">
        <button onClick={() => navigate('/')} className="w-9 h-9 bg-[#E8DDD2] rounded-full flex items-center justify-center"><CaretLeft size={18} /></button>
        <h1 className="font-heading text-lg font-bold text-[#1C1C1C]">Messages</h1>
      </header>
      <div className="p-4">
        {loading ? (
          <div className="flex items-center justify-center py-20"><div className="w-8 h-8 border-3 border-[#D4C5B3] border-t-[#E86A33] rounded-full animate-spin" /></div>
        ) : convos.length === 0 ? (
          <div className="text-center py-20">
            <ChatCircle size={48} className="text-[#E5E3DB] mx-auto mb-4" />
            <h3 className="font-heading text-lg font-bold text-[#1C1C1C] mb-2">No messages yet</h3>
            <p className="text-sm text-[#5C5C5C] font-body">Conversations will appear here when you chat with artisans or customers.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {convos.map(c => (
              <Link key={c.chat_id} to={`/chat/${c.last_message.job_id}/${c.other_user.id}`}
                className="block bg-white border border-[#D4C5B3] rounded-xl p-4 hover:-translate-y-0.5 hover:shadow-sm transition-all" data-testid={`convo-${c.chat_id}`}>
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-[#1A4D2E] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                    {c.other_user.name?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <h4 className="text-sm font-bold text-[#1C1C1C] font-body truncate">{c.other_user.name}</h4>
                      {c.unread > 0 && <span className="bg-[#E86A33] text-white text-[10px] font-bold px-2 py-0.5 rounded-full">{c.unread}</span>}
                    </div>
                    <p className="text-xs text-[#5C5C5C] truncate font-body mt-0.5">{c.last_message.message}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
